module.exports = __webpack_public_path__ + "f029c061a99bb8e1305ef5d96bdb5d37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/recommended.svg
// module id = 1937
// module chunks = 0